<template>
  <div :class="`form-element form-${type}-element`">
    <v-row no-gutters>
      <v-col
        v-if="options.type ==='radio'"
        cols="12"
      >
        <FormLabel
          :required="options.required"
          :title="options.title"
          :filled="internalValue !== undefined && internalValue !== null"
          :field-type="type"
        />
        <v-radio-group
          v-model="internalValue"
          hide-details
          class="mt-0"
        >
          <v-radio
            v-for="(v, key) in choices"
            :key="key"
            :label="v.value !== undefined ? v.value : v"
            :value="key"
            @click="radioClicked(key)"
          />
        </v-radio-group>
      </v-col>
      <v-col
        v-else
        cols="12"
      >
        <v-select
          v-model="internalValue"
          :items="selectChoices"
          :label="options.title"
          hide-details
          clearable
        >
          <template v-slot:label>
            <FormLabel
              input-label
              :required="options.required"
              :title="options.title"
              :filled="!!internalValue"
              :field-type="type"
            />
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-text-field
      v-if="options.custom_value && options.options.length === internalValue"
      :value="customValue"
      hide-details
      @input="changeCustomValue"
    />
  </div>
</template>

<script>
import FormLabel from '../FormLabel';

export default {
  components: {
    FormLabel
  },
  props: {
    value: { type: [String, Number], default: null },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data: () => ({
    customValue: null
  }),
  computed: {
    internalValue: {
      get () {
        const index = this.options.options.findIndex((el) => this.value === (el.value !== undefined ? el.value : el));

        // TODO: Move into watch value
        if (index === -1 && this.value !== null) {
          this.customValue = this.value;

          return this.options.options.length;
        }

        return index;
      },
      set (v) {
        if (this.options.options[v]) {
          this.customValue = null;
          const option = this.options.options[v];
          this.$emit('input', option.value !== undefined ? option.value : option); ;
        } else {
          if (this.options.options.length === v) {
            v = '';
          }

          this.$emit('input', v);
        }
      }
    },
    choices () {
      const options = JSON.parse(JSON.stringify(this.options.options));

      if (this.options.custom_value) {
        options.push(this.options.custom_value_label || this.$t('form.elements.select.custom'));
      }

      return options;
    },
    selectChoices () {
      const entries = [];
      const choices = this.choices;
      for (const i in choices) {
        entries.push({
          text: choices[i].label !== undefined ? choices[i].label : choices[i],
          value: +i
        });
      }

      return entries;
    }
  },
  methods: {
    changeCustomValue (v) {
      this.internalValue = v;
      this.customValue = v;
    },
    radioClicked (key) {
      if (this.internalValue === key) {
        key = null;
      }

      this.internalValue = key;
    }
  }
};
</script>
